(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6970,4333],{

/***/ 99550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50846);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _excluded = ["color", "size", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var XLg = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var color = _ref.color,
      size = _ref.size,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
  }));
});
XLg.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)]),
  title: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
XLg.defaultProps = {
  color: 'currentColor',
  size: '1em',
  title: null
};
/* harmony default export */ __webpack_exports__["Z"] = (XLg);

/***/ }),

/***/ 92042:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groups/[token]",
      function () {
        return __webpack_require__(57278);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23097);
/* harmony import */ var _helpers_application__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16828);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60463);



var AboutContent = function(param) {
    var group = param.group;
    var ref;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                        className: "text-uppercase text-gray1 label-2 d-flex align-items-center mb-1",
                        children: t("groups.new.description.label")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "font-size-md",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "pre-line",
                            dangerouslySetInnerHTML: {
                                __html: (0,_helpers_application__WEBPACK_IMPORTED_MODULE_1__/* .highlightLinksInText */ .w0)(group.description)
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-2 text-center",
                children: [
                    group.video_url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                        className: "ms-auto me-auto",
                        width: "100%",
                        height: "200",
                        src: group.video_url,
                        allowFullScreen: true
                    }),
                    ((ref = group.image) === null || ref === void 0 ? void 0 : ref.url) && !group.video_url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: group.image.url.replace("https://api.unalanu.com", "https://api.unalanu.com"),
                        style: {
                            maxWidth: "100%"
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AboutContent);


/***/ }),

/***/ 40698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46572);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shared_user_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36765);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60463);
/* harmony import */ var react_avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92124);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33616);






var MAX_USERS = 8;
var AvatarList = function(props) {
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("common").t;
    var maxUsers = props.maxUsers || MAX_USERS;
    var moreText = function() {
        return "+".concat(props.totalCount - maxUsers).split("").join(" ");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "d-flex avatar-list",
            children: [
                props.users.slice(0, maxUsers).map(function(user) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                        children: props.membersListLink || props.profilesLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: props.membersListLink ? props.membersListLink : "/profile/".concat(user.id),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "avatar-list_item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_user_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    name: user.first_name,
                                    src: user.avatar_thumb,
                                    width: 48,
                                    height: 48
                                })
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "avatar-list_item",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_user_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                name: user.first_name,
                                src: user.avatar_thumb,
                                width: 48,
                                height: 48
                            })
                        })
                    }, user.id);
                }),
                props.showMoreLink && props.totalCount && props.totalCount > maxUsers && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: props.membersListLink || "",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "avatar-list_item",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "avatar-container d-flex justify-content-center text-center rounded-circle p-0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "avatar d-flex aling-items-center justify-center rounded-circle object-fit-cover",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                    name: moreText(),
                                    size: 48,
                                    round: true,
                                    textSizeRatio: 4,
                                    color: "#E9F6F9",
                                    fgColor: "#161616"
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AvatarList);
AvatarList.defaultProps = {
    profilesLink: true
};


/***/ }),

/***/ 14333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23097);
/* harmony import */ var react_modal_sheet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94496);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var CustomSheet = function(props) {
    var header = props.header, children = props.children, onTapOut = props.onTapOut, wrapperClassName = props.wrapperClassName, passProps = _objectWithoutProperties(props, [
        "header",
        "children",
        "onTapOut",
        "wrapperClassName"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_modal_sheet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, passProps, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_modal_sheet__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Container */ .Z.Container, {
                children: [
                    props.header ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_modal_sheet__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Header */ .Z.Header, {
                        children: props.header
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_modal_sheet__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Header */ .Z.Header, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_modal_sheet__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Content */ .Z.Content, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_modal_sheet__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Scroller */ .Z.Scroller, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: props.wrapperClassName,
                                children: props.children
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_modal_sheet__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Backdrop */ .Z.Backdrop, {
                onTap: props.onTapOut
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (CustomSheet);
CustomSheet.defaultProps = {
    wrapperClassName: "container-sm"
};


/***/ }),

/***/ 22011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23097);

var BlockGap = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "d-grid gap-2",
        children: props.children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlockGap);


/***/ }),

/***/ 87658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ inviteUserToGroup; }
/* harmony export */ });
/* harmony import */ var _src_queries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36712);
/* harmony import */ var _sweet_alert_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72541);


var inviteUserToGroup = function(group, user, t, callback) {
    var Toast = _sweet_alert_helper__WEBPACK_IMPORTED_MODULE_1__/* .defaultToast */ .iL;
    (0,_src_queries__WEBPACK_IMPORTED_MODULE_0__/* .postGroupInviteUser */ .F)(group.token, user.id).then(function(response) {
        Toast.fire({
            icon: "success",
            title: t("invitations.invited", {
                user: user.first_name
            })
        });
        if (callback) callback();
    }).catch(function(error) {
        console.log(error);
    });
};


/***/ }),

/***/ 72541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iL": function() { return /* binding */ defaultToast; },
/* harmony export */   "ll": function() { return /* binding */ infoAlert; },
/* harmony export */   "uR": function() { return /* binding */ defaultToastSetting; }
/* harmony export */ });
/* unused harmony export okAlert */
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18888);
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_0__);

var defaultToastSetting = {
    toast: true,
    position: "bottom",
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true
};
var defaultToast = sweetalert2__WEBPACK_IMPORTED_MODULE_0___default().mixin(defaultToastSetting);
var infoAlert = function(title, text) {
    return okAlert("info", title, text);
};
var okAlert = function(icon, title, text) {
    sweetalert2__WEBPACK_IMPORTED_MODULE_0___default().fire({
        icon: icon,
        title: title,
        text: text,
        customClass: {
            confirmButton: "btn btn-primary"
        },
        buttonsStyling: false
    });
};


/***/ }),

/***/ 57278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _token_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(2082);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var react = __webpack_require__(1676);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 2 modules
var useTranslation = __webpack_require__(60463);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(78962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/sweetalert2/dist/sweetalert2.all.js
var sweetalert2_all = __webpack_require__(18888);
var sweetalert2_all_default = /*#__PURE__*/__webpack_require__.n(sweetalert2_all);
// EXTERNAL MODULE: ./helpers/application.js
var application = __webpack_require__(16828);
// EXTERNAL MODULE: ./helpers/group_helper.js
var group_helper = __webpack_require__(87658);
// EXTERNAL MODULE: ./helpers/sweet_alert_helper.js
var sweet_alert_helper = __webpack_require__(72541);
// EXTERNAL MODULE: ./src/queries.js
var queries = __webpack_require__(36712);
// EXTERNAL MODULE: ./components/navbars/navbar.js
var navbar = __webpack_require__(8064);
// EXTERNAL MODULE: ./components/navbars/navbar_bottom.js
var navbar_bottom = __webpack_require__(54897);
// EXTERNAL MODULE: ./components/shared/card.js
var card = __webpack_require__(74602);
// EXTERNAL MODULE: ./components/shared/custom_sheet.js
var custom_sheet = __webpack_require__(14333);
// EXTERNAL MODULE: ./components/shared/gap.js
var gap = __webpack_require__(22011);
// EXTERNAL MODULE: ./components/shared/image_icon.js + 1 modules
var image_icon = __webpack_require__(58082);
// EXTERNAL MODULE: ./components/shared/logo_image.js
var logo_image = __webpack_require__(98724);
// EXTERNAL MODULE: ./components/groups/avatar_list.js
var avatar_list = __webpack_require__(40698);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(50846);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/shared/red_dot.js
var red_dot = __webpack_require__(40665);
;// CONCATENATED MODULE: ./components/groups/group_tile.js





var GroupTile = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "col-3 text-center p-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            onClick: props.onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
                className: "card-crossroads",
                bodyClassName: "d-block p-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 d-flex align-items-center justify-content-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_icon/* default */.Z, {
                            name: props.icon,
                            width: 32,
                            height: 32
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "d-block col-12 text-center label-3 mb-0 mt-1",
                        children: props.text
                    }),
                    props.showRedDot > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(red_dot/* default */.Z, {})
                ]
            })
        })
    });
};
/* harmony default export */ var group_tile = (GroupTile);
GroupTile.propTypes = {
    text: (prop_types_default()).string.isRequired,
    onClick: (prop_types_default()).func.isRequired,
    icon: (prop_types_default()).string.isRequired,
    showRedDot: (prop_types_default()).bool
};
GroupTile.defaultProps = {
    showRedDot: false
};

// EXTERNAL MODULE: ./components/groups/events_list.js
var events_list = __webpack_require__(49868);
// EXTERNAL MODULE: ./components/shared/dummy_margin.js
var dummy_margin = __webpack_require__(19921);
// EXTERNAL MODULE: ./components/groups/about_content.js
var about_content = __webpack_require__(49293);
// EXTERNAL MODULE: ./node_modules/react-bootstrap-icons/dist/icons/x-lg.js
var x_lg = __webpack_require__(99550);
;// CONCATENATED MODULE: ./components/groups/detail.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


























var InviteSheet = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2775).then(__webpack_require__.bind(__webpack_require__, 72775));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72775)
            ];
        }
    },
    suspense: true
});
var Detail = function(props) {
    var ref12, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var ref9 = (0,node_modules_react.useState)(false), openInviteSheet = ref9[0], setOpenInviteSheet = ref9[1];
    var ref10 = (0,node_modules_react.useState)(false), openMenuSheet = ref10[0], setOpenMenuSheet = ref10[1];
    var router = (0,next_router.useRouter)();
    var groupURL = "".concat("https://unalanu.com").concat(router.asPath);
    var Toast = sweet_alert_helper/* defaultToast */.iL;
    var ref11 = (0,react.useSession)(), session = ref11.data;
    var membersLink = "/groups/".concat(props.group.token, "/members");
    var currentUserGroup = props.group.current_users_group;
    (0,node_modules_react.useEffect)(function() {
        var ref;
        if (((ref = props.group.current_users_group) === null || ref === void 0 ? void 0 : ref.status) == "approved" && props.group.undisplayed_events_count > 0) {
            (0,queries/* usersGroupDisplayedNow */.pi)(props.group.current_users_group.id);
        }
    }, [
        props.group.current_users_group,
        props.group.undisplayed_events_count
    ]);
    var handleDeleteGroup = function() {
        setOpenMenuSheet(false);
        sweetalert2_all_default().fire({
            title: t("groups.confirm_delete"),
            showDenyButton: false,
            showCancelButton: true,
            reverseButtons: false,
            confirmButtonText: t("delete"),
            cancelButtonText: t("cancel"),
            customClass: {
                confirmButton: "btn btn-danger text-white me-2",
                cancelButton: "btn btn-primary"
            },
            buttonsStyling: false
        }).then(function(result) {
            if (result.isConfirmed) {
                (0,queries/* deleteGroup */.iE)(props.group.token).then(function(response) {
                    sweetalert2_all_default().fire({
                        text: t("groups.delete_success"),
                        icon: "success",
                        customClass: {
                            confirmButton: "btn btn-primary"
                        },
                        buttonsStyling: false
                    }).then(function() {
                        router.push("/groups");
                    });
                }).catch(function(error) {
                    console.log(error);
                });
            }
        });
    };
    var inviteUserRequest = function(user) {
        (0,queries/* postGroupInviteUser */.F)(props.group.token, user.id).then(function(response) {
            props.refetch();
            Toast.fire({
                icon: "success",
                title: t("events.detail.requested")
            });
        }).catch(function(error) {
            console.log(error);
        });
    };
    var removeUserFromGroup = function(users_group) {
        setOpenMenuSheet(false);
        (0,queries/* deleteUsersGroup */.GS)(users_group.id).then(function(response) {
            props.refetch();
            Toast.fire({
                icon: "success",
                title: users_group.status === "approved" ? t("groups.leaved") : t("groups.request_canceled")
            });
        }).catch(function(error) {
            console.log(error);
        });
    };
    var joinGroup = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(users_group) {
            var newValue;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,queries/* approveUsersGroup */.xd)(users_group.id);
                    case 2:
                        newValue = _ctx.sent;
                        props.refetch();
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function joinGroup(users_group) {
            return _ref.apply(this, arguments);
        };
    }();
    var goToChat = function() {
        (0,queries/* getGroupChatRoom */.YS)(props.group.token).then(function(data) {
            router.push("/chat_rooms/".concat(data.id));
        }).catch(function(error) {
            console.log(error);
        });
    };
    var handleInviteClick = function() {
        setOpenMenuSheet(false);
        setOpenInviteSheet(true);
    };
    var handleAboutClick = function() {
        setOpenMenuSheet(false);
        router.push("/groups/".concat(props.group.token, "/about"));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-55 min-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "header bg bg-primary cover-image",
                style: {
                    backgroundImage: ((ref12 = props.group.cover_image) === null || ref12 === void 0 ? void 0 : ref12.url) ? "url(".concat(props.group.cover_image.url, ")") : ""
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar/* default */.Z, {
                        left: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "nav-item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "nav-link float-start ms-0 p-0 cover-image-btn p-1",
                                onClick: function() {
                                    return (0,application/* goBack */.Hm)(router, window);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(x_lg/* default */.Z, {
                                    size: application/* ICON_SIZE */.ZG
                                })
                            })
                        }),
                        fixed: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "d-flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header-images header-images--center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_image/* default */.Z, {
                                name: props.group.name,
                                src: props.group.logo_thumb,
                                width: 80,
                                height: 80
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container-sm position-relative pt-46",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header-images-content text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "mb-0",
                            children: props.group.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row row-cols-4 align-items-center justify-content-center",
                        children: [
                            (currentUserGroup === null || currentUserGroup === void 0 ? void 0 : currentUserGroup.status) === "approved" && /*#__PURE__*/ (0,jsx_runtime.jsx)(group_tile, {
                                text: t("events.title"),
                                icon: "hands",
                                onClick: function() {
                                    return router.push("/groups/".concat(props.group.token, "/events"));
                                },
                                showRedDot: props.group.undisplayed_events_count > 0
                            }),
                            (currentUserGroup === null || currentUserGroup === void 0 ? void 0 : currentUserGroup.status) !== "approved" || (currentUserGroup === null || currentUserGroup === void 0 ? void 0 : currentUserGroup.status) === "approved" && !props.group.community && !props.group.parent && /*#__PURE__*/ (0,jsx_runtime.jsx)(group_tile, {
                                text: t("invite"),
                                icon: "plus-accent",
                                onClick: handleInviteClick
                            }),
                            (currentUserGroup === null || currentUserGroup === void 0 ? void 0 : currentUserGroup.status) === "approved" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    props.group.community && /*#__PURE__*/ (0,jsx_runtime.jsx)(group_tile, {
                                        text: t("subgroups.title"),
                                        icon: "groups-blue",
                                        onClick: function() {
                                            return router.push("/groups/".concat(props.group.token, "/subgroups"));
                                        }
                                    }),
                                    props.group.parent && /*#__PURE__*/ (0,jsx_runtime.jsx)(group_tile, {
                                        text: t("community"),
                                        icon: "groups-blue",
                                        onClick: function() {
                                            return router.push("/groups/".concat(props.group.parent.token));
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(group_tile, {
                                        text: t("chats.title"),
                                        icon: "chat",
                                        onClick: goToChat
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(group_tile, {
                                        text: t("others"),
                                        icon: "dots-blue",
                                        onClick: function() {
                                            return setOpenMenuSheet(true);
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col text-secondary text-uppercase",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                            className: "float-start label-2 mb-12 text-gray1",
                                            children: "".concat(t("group"), " ").concat(t("members"))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col text-secondary text-uppercase"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: props.group.approved_members_count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_list/* default */.Z, {
                                    users: props.group.members,
                                    showMoreLink: membersLink,
                                    totalCount: props.group.approved_members_count,
                                    membersListLink: "/groups/".concat(props.group.token, "/members")
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                t("groups.no_members"),
                                                " ",
                                                "\uD83D\uDE1E"
                                            ]
                                        }),
                                        props.group.can_invite && (currentUserGroup === null || currentUserGroup === void 0 ? void 0 : currentUserGroup.status) === "approved" && /*#__PURE__*/ (0,jsx_runtime.jsx)(gap/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "btn btn-outline-primary btn-lg mt-3",
                                                onClick: function() {
                                                    return setOpenInviteSheet(true);
                                                },
                                                children: t("invite")
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            !currentUserGroup && (session === null || session === void 0 ? void 0 : session.user) && ((0,application/* isFalsey */.Vn)(props.group.parent) || ((ref1 = props.group) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.parent) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.current_users_group) === null || ref3 === void 0 ? void 0 : ref3.status) == "approved") && /*#__PURE__*/ (0,jsx_runtime.jsx)(gap/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "btn btn-primary btn-lg",
                                    onClick: function() {
                                        return inviteUserRequest(session.user);
                                    },
                                    children: t("groups.request_join")
                                })
                            }),
                            [
                                "invited_by_creator",
                                "invited"
                            ].includes(currentUserGroup === null || currentUserGroup === void 0 ? void 0 : currentUserGroup.status) && (session === null || session === void 0 ? void 0 : (ref4 = session.user) === null || ref4 === void 0 ? void 0 : ref4.id) == (currentUserGroup === null || currentUserGroup === void 0 ? void 0 : (ref5 = currentUserGroup.user) === null || ref5 === void 0 ? void 0 : ref5.id) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gap/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "btn btn-primary btn-lg",
                                            onClick: function() {
                                                return joinGroup(currentUserGroup);
                                            },
                                            children: t("approve")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gap/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "btn btn-outline-primary btn-lg mt-2 mb-3",
                                            onClick: function() {
                                                return removeUserFromGroup(currentUserGroup);
                                            },
                                            children: t("decline")
                                        })
                                    })
                                ]
                            }),
                            currentUserGroup && (0,application/* isTruthy */.fQ)(session === null || session === void 0 ? void 0 : session.user) && (session === null || session === void 0 ? void 0 : (ref6 = session.user) === null || ref6 === void 0 ? void 0 : ref6.id) == (currentUserGroup === null || currentUserGroup === void 0 ? void 0 : (ref7 = currentUserGroup.user) === null || ref7 === void 0 ? void 0 : ref7.id) && ![
                                "approved",
                                "invited_by_creator"
                            ].includes(currentUserGroup.status) && !currentUserGroup.is_admin && /*#__PURE__*/ (0,jsx_runtime.jsx)(gap/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "btn btn-outline-primary btn-lg",
                                    onClick: function() {
                                        return removeUserFromGroup(currentUserGroup);
                                    },
                                    children: currentUserGroup.status === "share_allowed" ? t("groups.opt_out") : t("events.detail.cancel_request")
                                })
                            }),
                            (currentUserGroup === null || currentUserGroup === void 0 ? void 0 : currentUserGroup.status) !== "approved" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(about_content/* default */.Z, {
                                    group: props.group
                                })
                            }),
                            !props.current_users_group && props.group.parent && ((ref8 = props.group.parent.current_users_group) === null || ref8 === void 0 ? void 0 : ref8.status) !== "approved" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-4",
                                children: [
                                    t("groups.new.community.join_hint"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                                        className: "justify-content-center mb-0",
                                        bodyClassName: "row",
                                        style: {
                                            backgroundColor: "#e9f6f9"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: function() {
                                                return router.push("/groups/".concat(props.group.parent.token));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex align-items-center col-auto px-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_image/* default */.Z, {
                                                            name: props.group.parent.name,
                                                            src: props.group.parent.logo_thumb,
                                                            width: 31,
                                                            height: 31
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col ms-2",
                                                        children: props.group.parent.name
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col text-secondary text-uppercase",
                                            children: ((currentUserGroup === null || currentUserGroup === void 0 ? void 0 : currentUserGroup.status) === "approved" || props.group.future_events_count != 0 || props.group.future_challenges_count != 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                className: "float-start label-2 mb-12 text-gray1",
                                                children: t("groups.next_events")
                                            })
                                        })
                                    }),
                                    (currentUserGroup === null || currentUserGroup === void 0 ? void 0 : currentUserGroup.status) === "approved" && props.group.future_events_count == 0 && props.group.future_challenges_count == 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "font-size-md fw-600",
                                                children: [
                                                    t("groups.no_events"),
                                                    " ",
                                                    "\uD83D\uDE1E"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(gap/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "".concat((0,application/* groupNewResourceLink */.gc)(props.group.token, "events")),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "btn btn-outline-primary btn-lg mt-2 mb-2",
                                                        children: t("events.create_first")
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(events_list/* default */.Z, {
                                        token: props.group.token,
                                        onlyList: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dummy_margin/* default */.Z, {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_bottom/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(node_modules_react.Suspense, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InviteSheet, {
                    name: props.group.name,
                    token: props.group.token,
                    url: groupURL,
                    queryCacheKey: "usersForInvite",
                    getUsersForInvite: queries/* getGroupUsersForInvite */.mc,
                    qParams: props.group.parent ? {
                        users_groups_group_id_eq: props.group.parent.id
                    } : {},
                    inviteUserClick: function(user) {
                        (0,group_helper/* inviteUserToGroup */.Q)(props.group, user, t, function() {
                            return refetch();
                        });
                    },
                    isOpen: openInviteSheet,
                    onClose: function() {
                        return setOpenInviteSheet(false);
                    },
                    refetchOnInvite: true
                })
            }),
            (props.group.can_update || props.group.can_destroy || (currentUserGroup === null || currentUserGroup === void 0 ? void 0 : currentUserGroup.status) === "approved") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(custom_sheet["default"], {
                isOpen: openMenuSheet,
                onClose: function() {
                    return setOpenMenuSheet(false);
                },
                snapPoints: [
                    0.9,
                    0
                ],
                onTapOut: function() {
                    return setOpenMenuSheet(false);
                },
                children: [
                    (currentUserGroup === null || currentUserGroup === void 0 ? void 0 : currentUserGroup.status) === "approved" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                onClick: handleAboutClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
                                    className: "mb2 text-secondary",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(image_icon/* default */.Z, {
                                            name: "about-blue",
                                            width: 24,
                                            height: 24
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ms-2",
                                            children: t("groups.new.description.label")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                onClick: function() {
                                    return router.replace("/groups/".concat(props.group.token, "/polls"));
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
                                    className: "mb2 text-secondary",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(image_icon/* default */.Z, {
                                            name: "chart-bar",
                                            width: 24,
                                            height: 24
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ms-2",
                                            children: t("polls.title")
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    (currentUserGroup === null || currentUserGroup === void 0 ? void 0 : currentUserGroup.status) === "approved" && (props.group.community || props.group.parent) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: handleInviteClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
                            className: "mb2 text-secondary",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(image_icon/* default */.Z, {
                                    name: "plus-accent",
                                    width: 24,
                                    height: 24
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ms-2",
                                    children: t("invite")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    props.group.can_update && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/groups/".concat(props.group.token, "/edit"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                                className: "mb-2 text-secondary",
                                children: t("groups.edit")
                            })
                        })
                    }),
                    props.group.can_destroy && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: handleDeleteGroup,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                            className: "mb-2 text-secondary",
                            children: t("groups.delete")
                        })
                    }),
                    (currentUserGroup === null || currentUserGroup === void 0 ? void 0 : currentUserGroup.status) === "approved" && !props.group.can_destroy && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: function() {
                            return removeUserFromGroup(currentUserGroup);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                            className: "mb-2 text-secondary",
                            children: t("groups.opt_out")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var detail = (Detail);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/events/PublicDetail.module.scss
var PublicDetail_module = __webpack_require__(9928);
var PublicDetail_module_default = /*#__PURE__*/__webpack_require__.n(PublicDetail_module);
// EXTERNAL MODULE: ./components/shared/user_image.js
var user_image = __webpack_require__(36765);
// EXTERNAL MODULE: ./node_modules/qrcode.react/lib/esm/index.js
var esm = __webpack_require__(89438);
;// CONCATENATED MODULE: ./components/groups/public_detail.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}









var PublicDetail = function(param) {
    var group = param.group, refetch = param.refetch;
    var ref;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var canvasId = "qr-gen";
    var groupPath = "/groups/".concat(group.token);
    var groupURL = "".concat("https://unalanu.com").concat(groupPath);
    var tz = "Europe/Prague";
    var signInLink = "/sign_in?redirectTo=".concat(groupPath);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container mb-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ms-1 me-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-3 mb-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/logo-black.svg",
                                width: 200,
                                height: 40,
                                alt: "Logo unalanu",
                                layout: "raw"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "m-auto"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "float-end me-1 mt-1 align-self-center",
                                href: signInLink,
                                children: t("common:profile.sign_in").toUpperCase()
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-md-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (PublicDetail_module_default()).cardbox,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((PublicDetail_module_default()).topbar, " cover-image header-images header-images-content"),
                                style: {
                                    backgroundImage: ((ref = group.cover_image) === null || ref === void 0 ? void 0 : ref.url) ? "url(".concat(group.cover_image.url.replace("http://unite-api-host", "http://localhost"), ")") : 'url("/images/bg-sport.png")'
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: group.logo_thumb.replace("https://api.unalanu.com", "https://api.unalanu.com"),
                                        style: _defineProperty({
                                            height: "100%",
                                            width: "auto",
                                            maxHeight: "140px",
                                            maxWidth: "140px",
                                            borderRadius: "360px",
                                            position: "absolute",
                                            right: "5%",
                                            bottom: "-3rem",
                                            border: "5px solid white"
                                        }, "borderRadius", "360px")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "p-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: (PublicDetail_module_default()).h1,
                                        children: group.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row mt-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-6 mb-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-flex",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_list/* default */.Z, {
                                                    users: group.members,
                                                    showMoreLink: false,
                                                    totalCount: group.approved_members_count,
                                                    membersListLink: null,
                                                    profilesLink: false
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((PublicDetail_module_default()).cardbox, " mt-4 p-3"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            children: "".concat((0,application/* capitalize */.kC)(t("about")), " ").concat(t("groups.one").toLowerCase())
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(about_content/* default */.Z, {
                                                group: group
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((PublicDetail_module_default()).cardbox, " mt-4 p-3"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            children: t("public:groups.become_member")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-flex",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row justify-content-between align-items-center mt-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-12 mb-3",
                                                        children: [
                                                            t("public:groups.join1", {
                                                                group: group.name
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: " unalanu "
                                                            }),
                                                            " ",
                                                            t("public:groups.join2")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-6 text-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://play.google.com/store/apps/details?id=com.railsformers.unalanu",
                                                            rel: "nofollow",
                                                            title: "Google Play",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "/images/google-play-badge.png",
                                                                width: 190,
                                                                height: 58,
                                                                alt: "Google Play store badge",
                                                                layout: "raw",
                                                                style: {
                                                                    width: "100%",
                                                                    height: "auto"
                                                                }
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-6 text-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://apps.apple.com/us/app/unalanu/id1642908664",
                                                            rel: "nofollow",
                                                            title: "App Store",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "/images/app-store-badge.png",
                                                                width: 180,
                                                                height: 60,
                                                                alt: "App Store badge",
                                                                layout: "raw",
                                                                style: {
                                                                    width: "100%",
                                                                    height: "auto"
                                                                }
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-3",
                                            children: t("public:join_text2")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-3 text-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                                                    value: groupURL,
                                                    id: canvasId
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "small",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "mt-1",
                                                        href: groupURL,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: t("public:open_in_app").toUpperCase()
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var public_detail = (PublicDetail);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(50219);
;// CONCATENATED MODULE: ./pages/groups/[token]/index.js







var Show = function() {
    var ref = (0,react.useSession)(), session = ref.data;
    var router = (0,next_router.useRouter)();
    var token = router.query.token;
    var ref1 = (0,useQuery/* useQuery */.a)([
        "groups",
        token
    ], function() {
        return (0,queries/* getGroup */.ex)(token);
    }, {
        onError: function(error) {
            return (0,queries/* handleError */.S3)(error, router);
        }
    }), group = ref1.data, refetch = ref1.refetch;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (session === null || session === void 0 ? void 0 : session.user) ? group && /*#__PURE__*/ (0,jsx_runtime.jsx)(detail, {
            refetch: refetch,
            group: group,
            backLink: router.query.backLink
        }) : group && /*#__PURE__*/ (0,jsx_runtime.jsx)(public_detail, {
            group: group,
            backLink: router.query.backLink
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _token_ = (Show);


/***/ }),

/***/ 9928:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardbox":"PublicDetail_cardbox__Jze_k","topbar":"PublicDetail_topbar__H0yPQ","h1":"PublicDetail_h1__Ji7E2","badge":"PublicDetail_badge__zGr6l"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,4227,443,4496,1348,3545,2124,8888,5501,8071,9438,1059,7641,3723,3623,7979,9868,9774,2888,179], function() { return __webpack_exec__(92042); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);